import React, { useEffect, useState } from "react";
import { Col, Container, Row, Table, Button, Image } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import bhareeLogo from "../../../../assets/images/bhareeLogo.png";
import TimestampConverter from "../../../../utils/TimestampConverter";
import isEmpty from "../../../../utils/is-Empty";
import "./invoicePage.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getInvoiceDetails,
  getUserAddressInfo,
  getUserCompanyInfo,
} from "../../../../actions/user.actions";
import PageSpinner from "../../../common/PageSpinner";
import { getApi } from "../../../../actions/structure.action";
import { appConstants, stringConstants } from "../../../../helpers/app-constants";

const InvoicePage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const qid = params.get("qid");

  const { addresses, gstStates, companyInfo, auth } = useSelector((state) => {
    return state;
  });

  const [loading, setLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [defaultAddress, setDefaultAddress] = useState(null);
  const [billingStateCode, setBillingStateCode] = useState("");
  const [sellerDefaultAddress, setSellerDefaultAddress] = useState(null);
  const [sellerCompanyInfo, setSellerCompanyInfo] = useState(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (!isEmpty(addresses) && addresses.data && addresses.data.length > 0) {
      const mAddress = addresses.data.find(
        (el) => el.set_default === 1 || el.address_type_id.type_name === "Billing",
      );
      setDefaultAddress(mAddress || addresses.data[0]);
    }
  }, [addresses]);

  useEffect(() => {
    if (!isEmpty(gstStates?.data) && !isEmpty(defaultAddress)) {
      let mState = defaultAddress.state;
      let foundState = gstStates.data.find((state) => state.state_name === mState);
      if (foundState) {
        setBillingStateCode(foundState.state_code);
      }
    }
  }, [defaultAddress, gstStates]);

  useEffect(() => {
    if (!isEmpty(gstStates?.data) && !isEmpty(sellerDefaultAddress)) {
      let mState = sellerDefaultAddress.state;
      let foundState = gstStates.data.find((state) => state.state_name === mState);
      if (foundState) {
        setBillingStateCode(foundState.state_code);
      }
    }
  }, [sellerDefaultAddress, gstStates]);

  useEffect(() => {
    // Fetch invoice data using the id from params
    getApi("getGstStates", dispatch);

    if (auth?.user?.role?.role_name === stringConstants.ROLL_BHAREE) {
      setLoading(true);
      getInvoiceDetails(id, dispatch, qid)
        .then((invoiceRes) => {
          if (invoiceRes.success) {
            setInvoiceData(invoiceRes.data);
          } else {
            setInvoiceData(null);
          }
        })
        .catch((err) => {
          console.error("Error fetching invoice:", err);
        })
        .finally(() => {
          setLoading(false);
        });

      // Get the seller default address
      getUserAddressInfo(qid, dispatch).then((res) => {
        const mSellerDefaultAddress = res?.data?.find(
          (el) => el.set_default === 1 || el.address_type_id.type_name === "Billing",
        );
        setSellerDefaultAddress(mSellerDefaultAddress || res?.data[0]);
      });

      // Get the seller company info
      getUserCompanyInfo(qid, dispatch).then((res) => {
        // console.log("Company Info Res: ", res);
        setSellerCompanyInfo(res);
      });
    } else {
      setLoading(true);
      getInvoiceDetails(id, dispatch)
        .then((invoiceRes) => {
          if (invoiceRes.success) {
            setInvoiceData(invoiceRes.data);
          } else {
            setInvoiceData(null);
          }
        })
        .catch((err) => {
          console.error("Error fetching invoice:", err);
        })
        .finally(() => {
          setLoading(false);
        });

      // Get the seller address
      getApi("getAddressess", dispatch);
      getApi("getCompanyInfo", dispatch);
    }
  }, [id, dispatch, auth, qid]);

  const handlePrint = () => {
    window.print();
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const invoiceContainer = () => {
    return (
      <>
        <Container className="mt-2 mb-2 p-0 no-print">
          <Row>
            <Col className="text-start">
              {auth?.user?.role?.role_name === stringConstants.ROLL_BHAREE ? (
                ""
              ) : (
                <Button className="btn btn-primary btn-sm" onClick={handleGoBack}>
                  <i class="bi bi-chevron-left"></i> Back
                </Button>
              )}
            </Col>
            <Col className="text-end">
              <Button className="btn btn-primary btn-sm" onClick={handlePrint}>
                <i class="bi bi-printer"></i> Print
              </Button>
            </Col>
          </Row>
        </Container>
        <Container className="p-4 w-100 invoice-container mb-4 mt-4 a4-container">
          <Row className="mb-1">
            <Col md={9} className="text-start">
              <h4>Tax Invoice for {invoiceData?.sellerInfo?.business_name}</h4>
            </Col>
            <Col md={3} className="d-flex justify-content-end align-items-center">
              <Image src={bhareeLogo} alt="bhareeLogo" style={{ width: 125 }} />
            </Col>
          </Row>
          <div className="separator"></div>
          <Row className="mt-3 mb-1">
            <Col className="text-start">
              <div className="mt-1">
                <p className="text-muted mb-0 label-text">Tax Invoice ID</p>
                <p className="value-text">{invoiceData?.numeric_id}</p>
              </div>
              <div className="mt-1">
                <p className="text-muted mb-0 label-text">Invoice Date</p>
                <p className="value-text">{TimestampConverter(invoiceData?.date * 1000)}</p>
              </div>
              <div className="mt-1">
                <p className="text-muted mb-0 label-text">Payment Method</p>
                <p className="value-text">{"Online"}</p>
              </div>
              <div className="mt-1">
                <p className="text-muted mb-0 label-text">Payment Transaction ID</p>
                <p className="value-text">{invoiceData?.payment_id}</p>
              </div>
            </Col>
            <Col className="text-end">
              <div className="mt-1">
                <p className="price-text mb-1">{invoiceData?.planDetails?.plan_total_amount} ₹</p>
              </div>
              <div className="mt-1">
                <p className="price-value-text">
                  Subtotal: {invoiceData?.planDetails?.plan_total_amount} ₹
                </p>
              </div>
              <div className="mt-1">
                <p className="price-value-text text-muted small">Includes:-</p>
                <p className="price-value-text">
                  SGST (9%): {(parseFloat(invoiceData?.planDetails?.plan_gst) / 2).toFixed(2)} ₹
                </p>
                <p className="price-value-text">
                  CGST (9%): {(parseFloat(invoiceData?.planDetails?.plan_gst) / 2).toFixed(2)} ₹
                </p>
                <p className="price-value-text">IGST (18%): 0.00 ₹</p>
              </div>
              <div className="mt-2"></div>
            </Col>
          </Row>
          <Table bordered hover className="vertical-borders-only align-middle no-hover">
            <thead>
              <tr>
                <th>#</th>
                <th className="text-start" style={{ width: 450 }}>
                  Item & Description
                </th>
                <th>HSN/ SAC</th>
                <th>Months</th>
                <th>Rate/ Month</th>
                <th>Total</th>
                <th>
                  Tax
                  <br />
                  Type
                </th>
                <th>
                  Tax
                  <br />
                  Amount
                </th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>01</td>
                <td className="text-start">
                  <span>
                    {`Bharee Subscription for ${invoiceData?.planDetails?.plan_title} (${invoiceData?.planDetails?.plan_subtitle})`}
                    <br />
                    <span className="fst-italic">{`₹ ${parseFloat(
                      invoiceData?.planDetails?.plan_unit_amount,
                    ).toFixed(0)}/month`}</span>
                    <br />
                    <span>
                      Start Date:{" "}
                      {TimestampConverter(invoiceData?.subscriptionDetails?.current_start * 1000)}
                    </span>
                    <br />
                    <span>
                      End Date:{" "}
                      {TimestampConverter(invoiceData?.subscriptionDetails?.next_billing_date)}
                    </span>
                  </span>
                </td>
                <td>{appConstants.SUBSCRIPTION_CHARGES_SAC}</td>
                <td>
                  {invoiceData?.planDetails?.plan_period === "month"
                    ? invoiceData?.planDetails?.plan_interval
                    : 12}
                </td>
                <td className="text-end">
                  {parseFloat(invoiceData?.planDetails?.plan_unit_amount).toFixed(0)}
                </td>
                <td className="text-end">
                  {parseFloat(invoiceData?.planDetails?.plan_amount).toFixed(0)}
                </td>
                <td className="text-end">
                  CGST(9%)
                  <br />
                  SGST(9%)
                </td>
                <td className="text-end">
                  <span>{`₹${(parseFloat(invoiceData?.planDetails?.plan_gst) / 2).toFixed(
                    2,
                  )}`}</span>
                  <br />
                  <span>{`₹${(parseFloat(invoiceData?.planDetails?.plan_gst) / 2).toFixed(
                    2,
                  )}`}</span>
                </td>
                <td className="text-end">{`₹${parseFloat(
                  invoiceData?.planDetails?.plan_total_amount,
                ).toFixed(0)}`}</td>
              </tr>

              {/* Add empty rows */}
              {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Row className="signature">
            <Col className="text-start">
              <p className="mb-0">
                <span className="text-muted label-text">Order Number: </span>
                <span className="value-text">{invoiceData?.order_id}</span>
                <br />
                <span className="text-muted label-text">Subscription ID: </span>
                <span className="value-text">{invoiceData?.subscriptionDetails?.id}</span>
                <br />
                <span className="text-muted label-text">Customer ID: </span>
                <span className="value-text">{invoiceData?.customer_details?.id}</span>
              </p>
            </Col>
            <Col className="text-end fw-bolder">
              <p className="mb-0 value-text">
                <span className="text-muted label-text">&nbsp;</span>
                <br />
                <br />
                <span className="value-text">Authorized Signatory</span>
              </p>
            </Col>
          </Row>
          <div className="separator"></div>
          <Row className="mt-1">
            <Col className="text-start">
              <p className="value-text mb-1">{invoiceData?.sellerInfo?.business_name}</p>
              <p className="text-muted label-text office-text">
                {defaultAddress?.address_line_1 || sellerDefaultAddress?.address_line_1}
              </p>
              <p className="text-muted label-text office-text">
                {defaultAddress?.city || sellerDefaultAddress?.city}{" "}
                {defaultAddress?.pin_code || sellerDefaultAddress?.pin_code}{" "}
                {defaultAddress?.state || sellerDefaultAddress?.state}{" "}
                {defaultAddress?.country || sellerDefaultAddress?.country}
              </p>
              <p className="text-muted label-text office-text">State code: {billingStateCode}</p>
              <p className="text-muted label-text office-text">
                Place of Supply: {defaultAddress?.state || sellerDefaultAddress?.state}
              </p>
              {(companyInfo?.data?.business_info?.gst_no ||
                sellerCompanyInfo?.data?.business_info?.gst_no) && (
                <p className="text-muted label-text office-text">
                  GSTIN:{" "}
                  {companyInfo?.data?.business_info?.gst_no ||
                    sellerCompanyInfo?.data?.business_info?.gst_no}
                </p>
              )}
            </Col>
            <Col className="text-end">
              <p className="value-text mb-1">{appConstants.BHAREE_BUSINESS_NAME}</p>
              <p className="text-muted label-text office-text">
                Office No 219 & 220, B Wing, Jai Ganesh Vision
              </p>
              <p className="text-muted label-text office-text">
                Akurdi, Pune, Maharashtra 411035 India
              </p>
              <p className="text-muted label-text office-text">contact@bharee.com</p>
              <p className="text-muted label-text office-text">
                GSTIN: {invoiceData?.bhareeBusinessInfo?.gst_no}
              </p>
              <p className="text-muted label-text office-text">
                <a href="https://www.bharee.com">www.bharee.com</a>
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mt-5">
              <p
                className="text-center fst-italic text-muted"
                style={{
                  fontSize: ".75em",
                }}
              >
                This is a computer generated invoice and does not require a physical signature
              </p>
            </Col>
          </Row>
        </Container>
      </>
    );
  };

  const noInvoiceContainer = () => {
    return (
      <Container className="mt-2 mb-2 p-0 no-print">
        <Row>
          <Col className="text-start">
            <Button className="btn btn-primary btn-sm" onClick={handleGoBack}>
              <i class="bi bi-chevron-left"></i> Back
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <p className="text-center">
              {loading ? "Loading data..." : "Invoice is not generated or not found."}
            </p>
          </Col>
        </Row>
      </Container>
    );
  };

  return (
    <>
      {loading && <PageSpinner />}
      {!isEmpty(invoiceData) ? invoiceContainer() : noInvoiceContainer()}
    </>
  );
};

export default InvoicePage;
